import * as React from 'react';

const statusMap = {
    IN_STOCK: (quantity)=>`in-stock${quantity ? '-with-quantity' : ''}`
    ,
    LOW_STOCK: (quantity)=>`low-stock${quantity ? '-with-quantity' : ''}`
    ,
    OUT_OF_STOCK: ()=>'out-of-stock'
    ,
    UNKNOWN: ()=>'unknown-stock'
};
const useGetStockStatusIdentifier = (stockStatus, quantity)=>React.useMemo(()=>{
        const status = statusMap[stockStatus];
        return status(quantity);
    }, [
        stockStatus,
        quantity
    ])
;

export { useGetStockStatusIdentifier };
//# sourceMappingURL=useGetStockStatusIdentifier.js.map
